import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import Translate from 'client/components/translate';
import Button from 'client/components/button/button';
import InputGroup from 'client/components/form/inputGroup';
import { PasswordRequirements, isPasswordValid } from 'client/components/form/passwordRequirements';
import { email } from 'web-core/src/utils/validate';

const valueErrorPropType = PropTypes.shape({
  value: PropTypes.string,
  error: PropTypes.shape({
    path: PropTypes.string,
  }),
});
const propTypes = {
  submitHandler: PropTypes.func.isRequired,
  isLogin: PropTypes.bool,
  headlinePath: PropTypes.string,
  ctaPath: PropTypes.string,
  data: PropTypes.shape({
    username: valueErrorPropType,
    password: valueErrorPropType,
  }).isRequired,
  changeHandler: PropTypes.func.isRequired,
};

const defaultProps = {
  headlinePath: 'common.account.create.hero.default',
  ctaPath: 'common.cta.continue',
  isLogin: false,
};

class AccountForm extends Component {
  onSubmit = (e) => {
    e.preventDefault();
    const {
      changeHandler,
      data: { username, password },
      isLogin,
    } = this.props;
    let err;
    let newState = this.props.data;
    newState = this.validateUsername(newState, username.value);
    newState = this.validatePassword(newState, password.value, isLogin);
    if (newState.username.error || newState.password.error) {
      changeHandler(newState);
      err = {
        message: null,
      };
    }
    const userVal = username.value;
    const passVal = password.value;
    return this.props.submitHandler(err, {
      email: userVal,
      password: passVal,
    });
    // .then((clearPassword) => {
    //   if (clearPassword) {
    //     const passCleared = {
    //       password: {
    //         value: '',
    //       },
    //     };
    //     const nextState = this.mergeVals(this.state, passCleared);
    //     this.setState(nextState);
    //   }
    // });
  };

  mergeVals(state, newVals) {
    return _.merge({}, state, newVals);
  }

  validateUsername(state, username) {
    const newState = {
      username: {
        error: null,
      },
    };
    if (!username) {
      newState.username.error = { path: 'common.form.error.required' };
    } else if (!email.test(username)) {
      newState.username.error = { path: 'common.error.invalidEmail' };
    }
    return this.mergeVals(state, newState);
  }

  validatePassword(state, password, isLogin) {
    const newState = {
      password: {
        error: null,
      },
    };
    if (!password) {
      newState.password.error = { path: 'common.form.error.required' };
    } else if (!isLogin && !isPasswordValid(password)) {
      newState.password.error = { path: 'common.error.passwordRequirements' };
    }
    return this.mergeVals(state, newState);
  }

  render() {
    const {
      changeHandler,
      data: { username, password },
      isLogin,
    } = this.props;

    const isFormValid = isLogin
      ? username.value && password.value
      : username.value && email.test(username.value) && isPasswordValid(password.value);

    return (
      <div className="create-form pad-top-2 pad-x-small-only">
        <h4 className="margin-bottom">
          <Translate path={this.props.headlinePath} />
        </h4>
        <form onSubmit={this.onSubmit}>
          <div>
            <InputGroup
              id="username"
              label={{
                path: 'common.label.email',
              }}
              type="text"
              value={username.value}
              onChange={(e) => {
                const newVal = e.target.value;
                let newState = this.mergeVals(this.props.data, { username: { value: newVal } });
                if (username.error) {
                  newState = this.validateUsername(newState, newVal);
                }
                changeHandler(newState);
              }}
              onBlur={() => {
                changeHandler(this.validateUsername(this.props.data, username.value));
              }}
              error={username.error} />
          </div>
          <div>
            <InputGroup
              autoComplete="off"
              id="password"
              label={{
                path: 'common.label.password',
              }}
              type="password"
              value={password.value}
              onChange={(e) => {
                const newVal = e.target.value;
                let newState = this.mergeVals(this.props.data, { password: { value: newVal } });
                if (password.error) {
                  newState = this.validatePassword(newState, newVal, isLogin);
                }
                changeHandler(newState);
              }}
              onBlur={() => {
                changeHandler(this.validatePassword(this.props.data, password.value, isLogin));
              }}
              error={password.error} />
          </div>
          {!isLogin && <PasswordRequirements password={password.value} className="margin-bottom" />}
          <Button className="cta-button" isDisabled={!isFormValid} type="submit">
            <Translate path={this.props.ctaPath} />
          </Button>
        </form>
      </div>
    );
  }
}
AccountForm.propTypes = propTypes;
AccountForm.defaultProps = defaultProps;

export default AccountForm;
